import createClient from "openapi-fetch";
import type { paths } from "./schema";

export function createApiClient(baseUrl: string) {
  return createClient<paths>({ baseUrl });
}

export class RequestTimeoutError extends Error {
  constructor() {
    super("request_timeout");
    this.name = "RequestTimeoutError";
  }
}

export async function withAbortableTimeout<T>(
  startRequest: (signal: AbortSignal) => Promise<T>,
  timeoutMs: number,
): Promise<T> {
  const controller = new AbortController();
  let timeoutId: ReturnType<typeof globalThis.setTimeout> | undefined;
  const timeout = new Promise<never>((_, reject) => {
    timeoutId = globalThis.setTimeout(() => {
      const error = new RequestTimeoutError();
      reject(error);
      controller.abort(error);
    }, timeoutMs);
  });

  try {
    const request = Promise.resolve().then(() =>
      startRequest(controller.signal),
    );
    return await Promise.race([request, timeout]);
  } finally {
    if (timeoutId !== undefined) globalThis.clearTimeout(timeoutId);
  }
}

export type { paths, components } from "./schema";
